module.exports = __webpack_public_path__ + "static/img/ring.214957d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ring.png
// module id = O/zD
// module chunks = 0